import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from '@/components/HomePage.vue'
import ProductApplicationPage from '@/components/ProductApplicationPage.vue'
import SpecificProducts from '@/components/SpecificProducts.vue'
import InnovativeManufacturing from '@/components/InnovativeManufacturing.vue'
import AboutUs from '@/components/AboutUs.vue'
import PartyMassWork from '@/components/PartyMassWork.vue'
import PartyMassWorkDetail from '@/components/PartyMassWorkDetail.vue'
import NewsCenter from '@/components/NewsCenter.vue'
import NewsDetail from '@/components/NewsDetail.vue'
import FumeiApp from '@/components/FumeiApp.vue'

export default createRouter({
  // 使用 Hash 模式而不是 History 模式
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomePage
    },
    {
      path: '/product-application/:categoryIndex?',
      name: 'ProductApplication',
      component: ProductApplicationPage,
      props: true
    },
    {
      path: '/specific-products',
      name: 'SpecificProducts',
      component: SpecificProducts
    },
    {
      path: '/innovative-manufacturing',
      name: 'InnovativeManufacturing',
      component: InnovativeManufacturing
    },
    {
      path: '/about-us',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/party-mass-work',
      name: 'PartyMassWork',
      component: PartyMassWork
    },
    {
      path: '/party-mass-work/detail',
      name: 'PartyMassWorkDetail',
      component: PartyMassWorkDetail
    },
    {
      path: '/news',
      name: 'NewsCenter',
      component: NewsCenter
    },
    {
      path: '/news/detail',
      name: 'NewsDetail',
      component: NewsDetail
    },
    {
      path: '/fumei-app',
      name: 'FumeiApp',
      component: FumeiApp
    }
  ]
})
